import { render, staticRenderFns } from "./multibanco.vue?vue&type=template&id=9fe25832&scoped=true"
import script from "./multibanco.vue?vue&type=script&lang=js"
export * from "./multibanco.vue?vue&type=script&lang=js"
import style0 from "./multibanco.vue?vue&type=style&index=0&id=9fe25832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe25832",
  null
  
)

export default component.exports